import { Columns3Cog } from 'lucide-react';
import * as React from 'react';

import { DimeFilterButton } from '../DimeFilterButton.js';
import { cn } from '../lib/utils.js';

type DataTableColumnsButtonProps = Readonly<
  Omit<React.ComponentProps<typeof DimeFilterButton>, 'label' | 'icon' | 'showChevron' | 'count'>
>;

/** The Columns menu trigger, shared by DataTableViewOptions and any app menu that replaces it. */
export const DataTableColumnsButton = React.forwardRef<
  HTMLButtonElement,
  DataTableColumnsButtonProps
>(function DataTableColumnsButton({ className, ...props }, ref) {
  return (
    <DimeFilterButton
      ref={ref}
      label="Columns"
      icon={<Columns3Cog className="size-3.5" aria-hidden />}
      showChevron
      className={cn('ml-auto', className)}
      {...props}
    />
  );
});
